<template>
  <path
    fill="currentColor"
    d="M12.111 10.833a1.197 1.197 0 1 0 2.394 0 1.197 1.197 0 0 0-2.394 0Zm10.983 10.56L17.626 7.242V2.035h2.146V0H4.45v2.035h2.146v5.207L1.129 21.393A1.917 1.917 0 0 0 2.916 24h18.391a1.913 1.913 0 0 0 1.787-2.607ZM8.63 7.622V2.095h6.96v5.527l2.72 7.041a7.697 7.697 0 0 0-1.912-.24 7.693 7.693 0 0 0-4.946 1.796 5.65 5.65 0 0 1-3.63 1.314 5.638 5.638 0 0 1-2.747-.71L8.63 7.623ZM3.089 21.965l1.248-3.226a7.697 7.697 0 0 0 3.489.832 7.694 7.694 0 0 0 4.947-1.795 5.65 5.65 0 0 1 3.63-1.314c1.047 0 2.046.284 2.92.81l1.81 4.693H3.09Z"
  />
</template>
